import { Grid, Input } from '@mui/material';
import { FC, useCallback } from 'react';
import Button from 'components/Button';
import EmptyState from 'components/EmptyState/EmptyState';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import { useLanguage } from 'context/AppContext';
import useDataUploadList from 'hooks/useDataUploadList';
import DataUploadListTable from '../molecules/DataUploadListTable';
import DataUploadPageTemplate from '../molecules/DataUploadPageTemplate';
import * as Styles from './DataUploadList.styles';

const DataUploadListPage: FC = () => {
  const { uploadList, getUploadList, loading, setRefresh } = useDataUploadList();
  const [language] = useLanguage();

  const handleChangeSearchInput = useCallback(
    async (e: any) => {
      e.preventDefault();
      await getUploadList(e.target.value);
    },
    [getUploadList],
  );

  return (
    <DataUploadPageTemplate>
      <Styles.DataUploadListPage>
        <Grid container justifyContent="space-between" direction="row" alignItems="center">
          <Grid item>
            <Input placeholder="Search" onChange={handleChangeSearchInput} autoFocus />
          </Grid>
          <Grid item>
            <Button onClick={() => setRefresh(true)}>{language.DataUpload.table.refresh}</Button>
          </Grid>
        </Grid>
        <Styles.PageSpinnerContainer>
          {loading ? (
            <PageSpinner />
          ) : (
            <>{uploadList.length > 0 ? <DataUploadListTable uploadedFiles={uploadList} /> : <EmptyState />}</>
          )}
        </Styles.PageSpinnerContainer>
      </Styles.DataUploadListPage>
    </DataUploadPageTemplate>
  );
};

export default DataUploadListPage;
